<template>
  <div>
    <div class="w3-col l8">
      <template v-if="!imageUpload">
        <template v-if="width > 600">
          <div class="sectionHeader">
            <h5>Inline Preview</h5>
          </div>
          <ul class="event-list">
            <li class="eventItem" style="cursor:pointer; animation:none;" @click="link(ad.url)">
              <div class="info" :class="ad.color" v-if="ad.title === '' && ad.text === '' && ad.button === ''">
                <div class="w3-row">
                  <div class="w3-col s9 m10 adInfo">
                    <h3 class="title">Placeholder Company</h3>
                    <p style="margin:0">$10 OFF Online Only</p>
                  </div>
                  <button class="w3-button adButton w3-display-right w3-margin-right" :class="ad.buttonColor">Learn More</button>
                </div>
              </div>
              <div class="info" :class="ad.color" v-else>
                <div class="w3-row">
                  <div class="w3-col s9 m10 adInfo">
                    <h3 class="title">{{ad.title}}</h3>
                    <p style="margin:0">{{ad.text}}</p>
                  </div>
                  <button class="w3-button adButton w3-display-right w3-margin-right" :class="ad.buttonColor">{{ad.button}}</button>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <div class="w3-row">
          <div class="w3-col s12 m6">
            <template v-if="width > 600">
              <div class="sectionHeader" style="text-align:center;">
                <h5>Sidebar Preview</h5>
              </div>
              <div style="margin:0 4px 8px; overflow:hidden; cursor:pointer;" @click="link(ad.url)">
                <div class='adContainer w3-display-container' :class="ad.color" style="min-height:258px; width:100%; overflow:hidden; animation:none;">
                  <div class="w3-display-middle w3-block" style="padding:15px" v-if="ad.title === '' && ad.text === '' && ad.button === ''">
                    <h3 >Placeholder Company</h3>
                    <p >$10 OFF Online Only</p>
                    <button class="w3-button adButton w3-margin-top" :class="ad.buttonColor" >Learn More</button>
                  </div>
                  <div class="w3-display-middle w3-block" style="padding:15px" v-else>
                    <h3>{{ad.title}}</h3>
                    <p>{{ad.text}}</p>
                    <button class="w3-button adButton w3-margin-top" :class="ad.buttonColor">{{ad.button}}</button>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="w3-col s12 m6">
            <div class="sectionHeader" style="text-align:center;">
              <h5>Mobile Preview</h5>
            </div>
            <div style="margin:0 4px 8px; overflow:hidden; cursor:pointer;" @click="link(ad.url)">
              <div class='adContainer w3-display-container' :class="ad.color" style="min-height:200px; width:100%; overflow:hidden; animation:none;">
                <div class="w3-display-middle w3-block" style="padding:15px 15px 25px;" v-if="ad.title === '' && ad.text === '' && ad.button === ''">
                  <h3 >Placeholder Company</h3>
                  <p >$10 OFF Online Only</p>
                  <button class="w3-button adButton" style="margin-top:5px" :class="ad.buttonColor" >Learn More</button>
                </div>
                <div class="w3-display-middle w3-block" style="padding:15px 12px 25px;" v-else>
                  <h3>{{ad.title}}</h3>
                  <p>{{ad.text}}</p>
                  <button class="w3-button adButton" style="margin-top:5px" :class="ad.buttonColor">{{ad.button}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="imageUpload">
        <template v-if="width > 600">
          <div class="sectionHeader w3-display-container" :style="currentUploadProgress && uploadType === 'inline' ? 'margin-bottom:0' : ''">
            <h5>Inline - (1050px x 140px)</h5>
            <input type="file" @change="uploadImage($event.target.files, 'inline')" ref="inline" name="inline" id="inline" accept=".png,.jpg" style="margin:8px 0; display:none;" />
            <button @click="$refs.inline.click()" class="w3-button adButton w3-display-right w3-red">Upload New Image</button>
          </div>
          <div style="margin:0 4px 4px;">
            <div class="progress" v-if="currentUploadProgress && uploadType === 'inline'">
              <div class="progress-bar w3-green" role="progressbar" :style="{width: (currentUploadProgress) + '%'}"></div>
            </div>
          </div>
          <ul class="event-list">
            <li class="eventItem eventItemImage" @click="link(ad.url)" :style="{'background-image': 'url(' + ad.images.inline + ')','animation':'none'}"></li>
          </ul>
        </template>
        <div class="w3-row">
          <div class="w3-col s12 m6">
            <template v-if="width > 600">
              <div class="sectionHeader w3-display-container" :style="currentUploadProgress && uploadType === 'sidebar' ? 'margin-bottom:0' : ''">
                <h5>Sidebar - (500px x 300px)</h5>
                <input type="file" @change="uploadImage($event.target.files, 'sidebar')" ref="sidebar" name="sidebar" id="sidebar" accept=".png,.jpg" style="margin:8px 0; display:none;" />
                <button @click="$refs.sidebar.click()" class="w3-button adButton w3-display-right w3-red">Upload New Image</button>
              </div>
              <div style="margin:0 4px 4px;">
                <div class="progress" v-if="currentUploadProgress && uploadType === 'sidebar'">
                  <div class="progress-bar w3-green" role="progressbar" :style="{width: (currentUploadProgress) + '%'}"></div>
                </div>
              </div>
              <div style="margin:0 4px 8px; overflow:hidden; cursor:pointer;" @click="link(ad.url)">
                <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:258px; width:100%; animation:none;" :style="{'background-image': 'url(' + ad.images.sidebar + ')'}"></div>
              </div>
            </template>
          </div>
          <div class="w3-col s12 m6">
            <div class="sectionHeader w3-display-container" :style="currentUploadProgress && uploadType === 'mobile' ? 'margin-bottom:0' : ''">
              <h5>Mobile - (500px x 22px)</h5>
              <input type="file" @change="uploadImage($event.target.files, 'mobile')" ref="mobile" name="mobile" id="mobile"  accept=".png,.jpg" style="margin:8px 0; display:none;" />
              <button @click="$refs.mobile.click()" class="w3-button adButton w3-display-right w3-red">Upload New Image</button>
            </div>
            <div style="margin:0 4px 4px;">
              <div class="progress" v-if="currentUploadProgress && uploadType === 'mobile'">
                <div class="progress-bar w3-green" role="progressbar" :style="{width: (currentUploadProgress) + '%'}"></div>
              </div>
            </div>
            <div style="margin:0 4px 8px; overflow:hidden; cursor:pointer;" @click="link(ad.url)">
              <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:200px; width:100%; animation:none;" :style="{'background-image': 'url(' + ad.images.mobile + ')'}"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    
    <div class="w3-col l4">
      <template v-if="!imageUpload">
        <template v-if="width > 600">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Upload Images</h5>
          </div>
          <div class="whiteContainer w3-margin-bottom w3-center">
            <p style="margin-bottom:10px;">Want to upload your own designs?<br/>Switch to the Ad Upload area</p>
            <button @click="switchBuilder('image')" class="w3-button w3-dark-blue w3-block" style="margin:0;">Use Image Uploader</button>
          </div>
        </template>
        <div class="sectionHeader" style="text-align:center;">
          <h5>Ad Builder</h5>
        </div>
        <div class="whiteContainer">
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="Ad Title" v-model="ad.title" />
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="yourwebsite.com/landing" v-model="ad.url" />
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="Ad Text 1" v-model="ad.text" maxlength="110" />
          <span style="margin: -26px 8px 0 0; float:right; font-size:8pt; color:#999;">{{ad.text.length}}/110</span>
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="Button Text" v-model="ad.button" maxlength="20" />
          <span style="margin: -26px 8px 0 0; float:right; font-size:8pt; color:#999;">{{ad.button.length}}/20</span>
      
          <button class="w3-button w3-dark-grey w3-block" style="margin:0;">Ad Color</button>
          <div class="w3-padding" style="background:#ddd">
            <div style="height:32px; width:352px; margin:0 auto;">
              <div v-for="(color, index) of colors" :key="index" class="colorItem">
                <div class="color" :class="color"  @click="selectBGColor(color)"></div>
              </div>
            </div>
          </div>
        
          <button class="w3-button w3-dark-grey w3-block" style="margin:0;">Button Color</button>
          <div class="w3-padding" style="background:#ddd">
            <div style="height:32px; width:352px; margin:0 auto;">
              <div v-for="(color, index) of colors" :key="index" class="colorItem">
                <div class="color" :class="color"  @click="selectButtonColor(color)"></div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="width < 601">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Upload Images</h5>
          </div>
          <div class="whiteContainer w3-margin-bottom w3-center">
            <p style="margin-bottom:10px;">Want to upload your own designs?<br/>Switch to the Ad Upload area</p>
            <button @click="switchBuilder('image')" class="w3-button w3-dark-blue w3-block" style="margin:0;">Use Image Uploader</button>
          </div>
        </template>
      </template>
      
      <template v-if="imageUpload">
        <template v-if="width > 600">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Ad Builder</h5>
          </div>
          <div class="whiteContainer w3-margin-bottom w3-center">
            <p style="margin-bottom:10px;">Prefer the Ad Builder?<br/>Switch to the Ad Builder area</p>
            <button @click="switchBuilder('builder')" class="w3-button w3-dark-blue w3-block" style="margin:0;">Use Ad Builder</button>
          </div>
        </template>

        <div class="sectionHeader" style="text-align:center;">
          <h5>Ad Details</h5>
        </div>
        <div class="whiteContainer w3-center">
          <p style="margin-bottom:10px;">Please enter a title to identify your ad</p>
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="Ad Title" v-model="ad.title" />
          <p style="margin-bottom:10px;">Please enter the link to your website or ad landing page</p>
          <input style="margin-bottom:8px;" class="w3-input w3-border" placeholder="yourwebsite.com/landing" v-model="ad.url" />
        </div>

        <template v-if="width < 601">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Ad Builder</h5>
          </div>
          <div class="whiteContainer w3-margin-bottom w3-center">
            <p style="margin-bottom:10px;">Prefer the Ad Builder?<br/>Switch to the Ad Builder area</p>
            <button @click="switchBuilder('builder')" class="w3-button w3-dark-blue w3-block" style="margin:0;">Use Ad Builder</button>
          </div>
        </template>
      </template>
      <div style="margin:0 4px 8px;">
        <button class="w3-button w3-green w3-block" @click="$emit('saveAd')">Save & Continue</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'adbuilder',
  props: ['ad'],
  computed: {
    ...mapState([
      'user',
      'currentUploadProgress',
      'imageUpload'
    ])
  },
  data() {
    return {
      uploadType: 'inline',
      colors: ['w3-white','w3-black','w3-blue','w3-red','w3-teal','w3-cyan','w3-orange','w3-green','w3-purple'],
      width: window.innerWidth
    }
  },
  methods: {
    switchBuilder(type) {
      if (type === 'image') {
        if (this.ad.images.inline === '' && this.ad.images.sidebar === '' && this.ad.images.mobile === '') {
          this.ad.images = {
            inline: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-inline.jpg?alt=media&token=b437a531-509c-446b-91a6-5892ff2652d6',
            sidebar: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-sidebar.jpg?alt=media&token=6ae9c073-bbfb-47f3-bfc9-aac790bc3f7f',
            mobile: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-mobile.jpg?alt=media&token=a1cb5807-834a-4380-979a-2e187a04a585'
          }
        }
        this.$store.commit('setImageUpload', true)
        window.scrollTo(0, 0)
        return
      }
      if (type === 'builder') {
        if (this.ad.images.inline !== 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-inline.jpg?alt=media&token=b437a531-509c-446b-91a6-5892ff2652d6' || this.ad.images.sidebar !== 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-sidebar.jpg?alt=media&token=6ae9c073-bbfb-47f3-bfc9-aac790bc3f7f' || this.ad.images.mobile !== 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-mobile.jpg?alt=media&token=a1cb5807-834a-4380-979a-2e187a04a585') {
          let choice = confirm('Do you want to discard your changes and use the ad builder?')
          if (!choice) {
            return
          }
        }
        this.ad.images = {
          inline: '',
          sidebar: '',
          mobile: ''
        }
        this.$store.commit('setImageUpload', false)
        window.scrollTo(0, 0)
        return
      }
    },
    uploadImage(files, type) {
      this.uploadType = type
      if (files[0] !== undefined) {
        const fileName = files[0].name
        if (fileName.lastIndexOf(".") <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener("load", () => {
          const imageBlob = fr.result
          let postData = {
            files: files,
            type: type,
            uid: this.user.uid,
            name: fileName
          }
          this.$store.dispatch('uploadAdImage', postData).then((result) => {
            if (result.message === 'success') {
              this.ad.images[type] = result.imageURL
            }
          })
        })
      }
    },
    removeImage(type) {
      this.ad.images[type] = ''
      this.$refs[type].value = ''
    },
    selectBGColor(color) {
      this.ad.color = color
    },
    selectButtonColor(color) {
      this.ad.buttonColor = color
    }
  }
}
var wordlist = ['acrotomophilia','alabama hot pocket','alaskan pipeline','anal','anilingus','anus','apeshit','arsehole','ass','asshole','assmunch','auto erotic','autoerotic','babeland','baby batter','baby juice','ball gag','ball gravy','ball kicking','ball licking','ball sack','ball sucking','bangbros','bareback','barely legal','barenaked','bastard','bastardo','bastinado','bbw','bdsm','beaner','beaners','beaver cleaver','beaver lips','bestiality','big black','big breasts','big knockers','big tits','bimbos','birdlock','bitch','bitches','black cock','blonde action','blonde on blonde action','blowjob','blow job','blow your load','blue waffle','blumpkin','bollocks','bondage','boner','boob','boobs','booty call','brown showers','brunette action','bukkake','bulldyke','bullet vibe','bullshit','bung hole','bunghole','busty','butt','buttcheeks','butthole','camel toe','camgirl','camslut','camwhore','carpet muncher','carpetmuncher','chocolate rosebuds','circlejerk','cleveland steamer','clit','clitoris','clover clamps','clusterfuck','cock','cocks','coprolagnia','coprophilia','cornhole','coon','coons','creampie','cum','cumming','cunnilingus','cunt','darkie','date rape','daterape','deep throat','deepthroat','dendrophilia','dick','dildo','dingleberry','dingleberries','dirty pillows','dirty sanchez','doggie style','doggiestyle','doggy style','doggystyle','dog style','dolcett','domination','dominatrix','dommes','donkey punch','double dong','double penetration','dp action','dry hump','dvda','eat my ass','ecchi','ejaculation','erotic','erotism','escort','eunuch','faggot','fecal','felch','fellatio','feltch','female squirting','femdom','figging','fingerbang','fingering','fisting','foot fetish','footjob','frotting','fuck','fuck buttons','fuckin','fucking','fucktards','fudge packer','fudgepacker','futanari','gang bang','gay sex','genitals','giant cock','girl on','girl on top','girls gone wild','goatcx','goatse','god damn','gokkun','golden shower','goodpoop','goo girl','goregasm','grope','group sex','g-spot','guro','hand job','handjob','hard core','hardcore','hentai','homoerotic','honkey','hooker','hot carl','hot chick','how to kill','how to murder','huge fat','humping','incest','intercourse','jack off','jail bait','jailbait','jelly donut','jerk off','jigaboo','jiggaboo','jiggerboo','jizz','juggs','kike','kinbaku','kinkster','kinky','knobbing','leather restraint','leather straight jacket','lemon party','lolita','lovemaking','make me come','male squirting','masturbate','menage a trois','milf','missionary position','motherfucker','mound of venus','mr hands','muff diver','muffdiving','nambla','nawashi','negro','neonazi','nigga','nigger','nig nog','nimphomania','nipple','nipples','nsfw images','nude','nudity','nympho','nymphomania','octopussy','omorashi','one cup two girls','one guy one jar','orgasm','orgy','paedophile','paki','panties','panty','pedobear','pedophile','pegging','penis','phone sex','piece of shit','pissing','piss pig','pisspig','playboy','pleasure chest','pole smoker','ponyplay','poof','poon','poontang','punany','poop chute','poopchute','porn','porno','pornography','prince albert piercing','pthc','pubes','pussy','queaf','queef','quim','raghead','raging boner','rape','raping','rapist','rectum','reverse cowgirl','rimjob','rimming','rosy palm','rosy palm and her 5 sisters','rusty trombone','sadism','santorum','scat','schlong','scissoring','semen','sex','sexo','sexy','shaved beaver','shaved pussy','shemale','shibari','shit','shitblimp','shitty','shota','shrimping','skeet','slanteye','slut','s&m','smut','snatch','snowballing','sodomize','sodomy','spic','splooge','splooge moose','spooge','spread legs','spunk','strap on','strapon','strappado','strip club','style doggy','suck','sucks','suicide girls','sultry women','swastika','swinger','tainted love','taste my','tea bagging','threesome','throating','tied up','tight white','tit','tits','titties','titty','tongue in a','topless','tosser','towelhead','tranny','tribadism','tub girl','tubgirl','tushy','twat','twink','twinkie','two girls one cup','undressing','upskirt','urethra play','urophilia','vagina','venus mound','vibrator','violet wand','vorarephilia','voyeur','vulva','wank','wetback','wet dream','white power','wrapping men','wrinkled starfish','xx','xxx','yaoi','yellow showers','yiffy','zoophilia','🖕']
</script>
